/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Meta_TitleInputs */

const en_wc_tut_meta_title = /** @type {(inputs: Wc_Tut_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft Tutorial: Beginner's Guide to the Free Word Alternative`)
};

/**
* | output |
* | --- |
* | "WordCraft Tutorial: Beginner's Guide to the Free Word Alternative" |
*
* @param {Wc_Tut_Meta_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_meta_title = /** @type {((inputs?: Wc_Tut_Meta_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Meta_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_meta_title(inputs)
});
export { wc_tut_meta_title as "wc.tut.meta_title" }